import {remCalc} from '../../_utils'

export default {
    baseStyle: {
        currentPrice: {
            textStyle: 'head-medium',
            color: 'text.default',
            fontWeight: {base: 'medium', lg: 'bold'},
        },
        listPrice: {
            textStyle: 'body-medium',
            color: 'text.secondary',
        },
        suggested: {
            textStyle: 'body-small',
            color: 'text.secondary',
        },
        discount: {
            textStyle: 'body-medium',
            color: 'text.secondary',
        },
        container: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(24),
            alignSelf: 'stretch',
        },
        priceBoxIva: {
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: remCalc(16),
        },
        priceBox: {
            display: 'flex',
            alignItems: 'center',
            gap: remCalc(10),
        },
        button: {
            display: 'flex',
            height: remCalc(40),
            minWidth: [remCalc(226), remCalc(226), remCalc(140), remCalc(140)],
            maxHeight: remCalc(40),
            padding: `${remCalc(18)} ${remCalc(22)}`,
            justifyContent: 'center',
            alignItems: 'center',
            gap: remCalc(10),
            alignSelf: 'stretch',
            variant: 'primary',
            textStyle: 'body-medium',
            letterSpacing: remCalc(0.4),
            textAlign: 'center',
            fontWeight: 'bold',
        },
        infoIcon: {
            boxSize: remCalc(22.8),
            color: 'text.default',
            cursor: 'pointer',
        },
    },
    variants: {
        pdpSelectorDrawerCard: {
            currentPrice: {
                textStyle: 'body-small',
                fontWeight: 'bold',
            },
            discount: {
                textStyle: 'body-xsmall',
            },
            listPrice: {
                textStyle: 'body-xsmall',
            },
            suggested: {
                textStyle: 'body-xsmall',
            },
            infoIcon: {
                boxSize: remCalc(12),
            },
        },
        pdpSelectorCurrentVariant: {
            currentPrice: {
                textStyle: 'head-small',
                fontWeight: 'bold',
            },
            discount: {
                textStyle: 'body-xsmall',
            },
            listPrice: {
                textStyle: 'body-xsmall',
            },
            infoIcon: {
                boxSize: remCalc(12),
            },
        },
    },
}
